module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAANAAkDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAACAf/xAAnEAAABQMCBQUAAAAAAAAAAAABAgMEEQAFEgYHCBMVIZIxUlSC0f/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwC86f3o3Bf6jvrRS6JFt7e9vWqWDTmLJpJKCAgIxAzkTH7SPYApN9Wf+0/iX8ojNuE1dTdq+3gutnKCRrm5eg0RZiUoioc4wcebBsZiY7x6UvOgD8o/jQf/2Q=="


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/00276r.jpg
// module id = OSeg
// module chunks = 1